// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"132db127","123":"dae41499","629":"132db127","994":"32f706e8"}[chunkId] + ".chunk.css";
};